'use client';
import React, { useCallback } from 'react';
import Head from 'next/head';
/* eslint-disable */
// @ts-ignore
import { AdSlot, DFPSlotsProvider, DFPManager } from 'react-dfp';
import styled from '@benzinga/themetron';

declare global {
  interface Window {
    adthrive: {
      cmd?: unknown[];
      plugin?: string;
      host?: string;
      disableAds?: () => void;
    };
  }
}

export type Viewport = [number, number];
export type Sizes = (string[] | number[])[];

export interface SizeMap {
  sizes: Sizes;
  viewport: Viewport;
}

export interface GoogleAdUnitProps {
  adUnit: string;
  slotId?: string;
  dfpNetworkId: string;
  onRender?: (value: boolean) => void;
  sizeMapping?: SizeMap[];
  sizes: Sizes;
  loadDelay?: number;
}

export const GoogleAdUnit: React.FC<GoogleAdUnitProps> = ({
  adUnit,
  dfpNetworkId,
  loadDelay = 100,
  onRender,
  sizeMapping,
  sizes,
  slotId,
}) => {
  const handleVisibilityChange = useCallback(() => {
    onRender && onRender(true);
  }, [onRender]);

  React.useEffect(() => {
    setTimeout(() => {
      DFPManager.getGoogletag().then(googletag => {
        // if (window?.adthrive?.cmd) {
        //   window.adthrive.cmd.push(function () {
        //     googletag.cmd.push(function () {
        //       googletag.defineSlot(`/${dfpNetworkId}/${adUnit}`, sizes, slotId)?.addService(googletag.pubads());
        //       googletag.pubads().refresh();
        //     });
        //   });
        // }
        googletag.cmd.push(() => {
          googletag.pubads().refresh();
        });
      });
    }, loadDelay);
  }, [adUnit, loadDelay, slotId]);

  return (
    <>
      <Head>
        <link href="https://pagead2.googlesyndication.com" rel="dns-prefetch" />
        <link href="https://partner.googleadservices.com" rel="dns-prefetch" />
        <link href="https://tpc.googlesyndication.com" rel="dns-prefetch" />
      </Head>
      <DFPSlotsProvider
        dfpNetworkId={dfpNetworkId}
        disableInitialLoad
        lazyLoad={{ fetchMarginPercent: 110, mobileScaling: 2.0, renderMarginPercent: 120 }}
      >
        <AdWrapper>
          <AdSlot
            adUnit={adUnit}
            onSlotRender={handleVisibilityChange}
            onSlotVisibilityChanged={handleVisibilityChange}
            sizeMapping={sizeMapping}
            sizes={sizes}
            slotId={slotId || adUnit}
          />
        </AdWrapper>
      </DFPSlotsProvider>
    </>
  );
};

const AdWrapper = styled.div`
  align-items: center;
  display: flex;
  margin: auto;
  .adBox {
    align-items: center;
    display: flex;
  }
  iframe {
    margin: auto;
  }
`;
